module.exports = __webpack_public_path__ + "img/icon_city.0eea97ea.png";